import { MyTasksState, MyTasksActionTypes, READ_MY_TASKS_DATA_REQUEST, READ_MY_TASKS_DATA_SUCCESS, READ_MY_TASKS_DATA_FAILURE } from "store/reducers/types/myTasks/myTasks";

const defaultState: MyTasksState = {
  isLoading: false,
  errorMessage: ""
};

export default function myTasks(state = defaultState, action: MyTasksActionTypes): MyTasksState {
  switch (action.type) {
    case READ_MY_TASKS_DATA_REQUEST:
      return {
        ...state,
        isLoading: true
      };
    case READ_MY_TASKS_DATA_SUCCESS:
      return {
        ...state,
        contents: action.contents,
        isLoading: false,
        errorMessage: ""
      };
    case READ_MY_TASKS_DATA_FAILURE:
      return {
        ...state,
        isLoading: false,
        errorMessage: ""
      };
    default:
      return state;
  }
};